// extracted by mini-css-extract-plugin
export default {"wrapper":"E0-z","play":"F0-z"};